import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/StakeholderTips.module.scss';

const TipStakeholderFunctionalDriver = () => {
  const { t } = useTranslation();
  return (
    <Tip
      styleTipTextContainer={styles.driverContainer}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipStakeholderFunctionalDriver')}
      </p>
    </Tip>
  );
};

export default TipStakeholderFunctionalDriver;
